var urltype = process.env.NODE_ENV == "development"; //判断是否为本地环境
const protocol = window.location.protocol + "//"; // 判断当前协议是: http: 或 https:
const protocols = "https://";
//*******php引入接口*************************************************************************************/
// let devUrl = 'gys.yaojuli.com/apis';// 正式
// let devUrl = 'pregys.yaojuli.com/apis';// 灰度
let devUrl = "testgys.yaojuli.com/apis"; // 测试

var baseURL = urltype ? protocols + devUrl : window.location.origin + "/apis";

/*******java接口*******************************************************************************************/
let proUrlyunapp = "yygproapi.yaojuli.com"; // 阿里云正式地址
let csUrlapp = "testyygproapi.yaojuli.com"; // 测试

// let devUrlapp = protocols + 'yygproapi.yaojuli.com';// 正式
let devUrlapp = protocols + "testyygproapi.yaojuli.com"; // 测试
// let devUrlapp = protocol + "192.168.35.164:10010"; // 罗申洪本地
console.log("window.location.origin：", window.location.origin);

var javaUrl =
  window.location.origin.indexOf("testcw.yaojuli.com") != -1
    ? csUrlapp
    : proUrlyunapp;
var baseURLapp = urltype ? devUrlapp : protocols + javaUrl;

window.localStorage.setItem("appUrl", baseURLapp);
window.localStorage.setItem("phpUrl", baseURL);
export { baseURL, baseURLapp };
